var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionMarkX2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 18C13 18.5523 12.5523 19 12 19C11.4477 19 11 18.5523 11 18C11 17.4477 11.4477 17 12 17C12.5523 17 13 17.4477 13 18Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9971 5.00001L11.9994 5C13.1477 5 14.3534 5.28406 15.3043 5.9179C16.2849 6.57149 17 7.61197 17 9C17 9.97808 16.7934 10.8685 16.2095 11.648C15.6434 12.4035 14.8015 12.9475 13.7487 13.407C13.2693 13.6163 12.9994 14.0349 12.9994 14.4416V15C12.9994 15.5523 12.5517 16 11.9994 16C11.4471 16 10.9994 15.5523 10.9994 15V14.4416C10.9994 13.1266 11.85 12.0536 12.9486 11.5741C13.8554 11.1783 14.3391 10.8087 14.6088 10.4488C14.8607 10.1126 15 9.68546 15 9C15 8.38804 14.7148 7.92852 14.1951 7.58211C13.646 7.21611 12.8518 7.00019 12.0005 7C11.1474 7.00214 10.3528 7.21835 9.80389 7.58398C9.28471 7.9298 9 8.38809 9 9C9 9.55229 8.55228 10 8 10C7.44772 10 7 9.55229 7 9C7 7.61191 7.71474 6.57248 8.69515 5.91944C9.64556 5.28638 10.8502 5.00262 11.9971 5.00001Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMarkX2);
export default __webpack_public_path__ + "static/media/QuestionMarkX2.b7fae550a94b61e476323f5cf64d55c9.svg";
export { ForwardRef as ReactComponent };